import {push} from 'react-router-redux'
import {CATEGORY} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import types from '../types/costs'
import simpleSnackbarActions from '../../../common/actions/simpleSnackbar'
import {endpoint as endpointText} from '../../../common/text'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class costs {

  static setOpen(open) {
    return {
      type: types.SET_OPEN,
      payload: {
        open,
      },
    }
  }

  static fetch() {
    return function(dispatch) {

      dispatch({type: types.FETCH})

      apiPrivate.get(CATEGORY + '/prices')
        .then(response => {
          const data = response.data.description.prices || []
          dispatch(costs.fetchSuccess(data))
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(costs.fetchFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(costs.fetchFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
        })
    }
  }

  static fetchSuccess(data) {

    const getImage = (index) => {
      switch (index % 3) {
        case 0:
          return '/assets/costsClothes.png'
        case 1:
          return '/assets/costsBicycle.png'
        case 2:
          return '/assets/costsBox.png'
        default:
          return ''
      }
    }

    return {
      type: types.FETCH_SUCCESS,
      payload: {
        costs: data.map((c, i) => ({
          id: c.ID,
          price: c.Price,
          name: c.Description,
          description: c.Examples,
          picture: getImage(i),
        })),
      },
    }
  }

  static fetchFail(error) {
    return {
      type: types.FETCH_FAIL,
      payload: {
        error,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/yours/actions/costs.js